import React, { useState, useEffect, useContext, useRef } from "react";
// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Calendar, InputText, InputTextarea, classNames } from "primereact";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import Card from "../../../Base/Components/Card/Card";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";

import { ObtenerSiguienteNoIngreso } from "../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { getOrdenesDetalles } from "../../../API/Compras/Ordenes/OrdenesComprasRequests";
import { RedondearNumero } from "../../../utils/Funciones/FuncionesGenerales";

import OverlayProveedorCAI from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/OverlayProveedorCAI";
import LiquidacionDeIngresos from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/LiquidacionDeIngresos";
import OverlayOC from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/OverlayOC";
import OverlayOCD from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/OverlayOCD";
import OverlayLiquidaciones from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/OverlayLiquidaciones";
import OverlayLiquidacionesDetalles from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/OverlayLiquidacionesDetalles";
import { cambiarRecibidofinanzas, volverARecibido } from "../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import ModalDividirDetalles from "./ModalDividirDetalles";

const EncabezadoIngresos = ({
  values,
  detalles,
  handleInputChange,
  proveedor,
  habilitar,
  setHabilitar,
  resetForm,
  guardarIngresosBodega,
  guardarIngresos,
  setValues,
  getIngreso,
  agregarNuevaFila,
  eliminarItemDetalle,
  setDetalles,
  addOC,
  setIngresoToShow,
  guardarRequisa = () => {},
  setShowPOColumn,
  showPOColumn,
  hab,
  term,
  checkDollar,
  setCheckDollar,
  setLoading,
  setVerCostosBodega,
  verCostosBodega,
  isMateriaPrima,
  tiposIngreso,
  addSingleOC,
  cuentas,
  serviciosNuevo,
  selectedDet,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [NoIngreso, setNoIngreso] = useState([]);
  const [selectProveedor, setSelectProveedor] = useState(null);

  const [ingresoSinOC, setIngresoSinOC] = useState(userAuth.AccessWeb.split(",") .map((e) => parseInt(e)).includes(39) || userAuth.IdRol == 1 );

  const [verCostos, setVerCostos] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(49) || userAuth.IdRol == 1);
  const [showDialogLiquidacion, setShowDialogLiquidacion] = useState(false);
  const [showDialogLote, setShowDialogLote] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dialogDividir, setDialogDividir] = useState(false);
  
  const handleTogglePOColumn = () => {
    setShowPOColumn(prevState => !prevState); 
  };

  const handleProveedorChange = (selectedValue) => {
    let valor = { ...selectedValue.value };
    values.IdProveedor = valor.IdVendor;
    setSelectProveedor(selectedValue);
  };

  const habilitarComponentes = () => {
    let valor = values.IdVendor
    values.IdProveedor = valor;
    setHabilitar(true);
  };
    
  const verificarCampos = () => {
    let err = false;

    if(showPOColumn){
      if(!values?.IdPurchaseOrder){
        err = true;
        toastShow(toast, "error", "Error", "Debe seleccionar una OC.");
        return true
      }
    }
    
    if(!values?.IdTipoIngreso && !values?.Inventario?.IdTipoIngreso){
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar un Tipo de Ingreso.");
    }else if (!values.CustomerName) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar un Proveedor.");
    } else if (!values?.Factura) {
      err = true;
      toastShow(toast, "error", "Error", "Debe ingresar una factura.");
    } else if (!values.Comentarios) {
      err = true;
      toastShow(toast, "error", "Error", "Debe ingresar un comentario.");
    } 
    else if (!values.TasaCambio) {
      err = true;
      toastShow(toast, "error", "Error", "Debe ingresar una Tasa de Cambio.");
    } else if (!/^\d+(\.\d+)?$/.test(values.TasaCambio)) {
      err = true;
      toastShow(toast, "error", "Error", "La Tasa de Cambio solo puede contener números y un solo punto.");
    } else if (!values.Term) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar un Término de Compra.");
    } 
    //---------LIQUIDACIONES
    if(values?.Embalaje){
      if(!values?.TasaCambioEmbalaje){
        err = true;
        toastShow(toast, "error", "Error", "Tasa Cambio de embalaje es requerida.");
      }
    }
    if(values?.Desaduanaje){
      if(!values?.TasaCambioDesaduanaje){
        err = true;
        toastShow(toast, "error", "Error", "Tasa Cambio de desaduanaje es requerida.");
      }
    }
    if(values?.Flete){
      if(!values?.TasaCambioFlete){
        err = true;
        toastShow(toast, "error", "Error", "Tasa Cambio de flete es requerida.");
      }
    }
    if(values?.OtrosCostos){
      if(!values?.TasaCambioOtrosCostos){
        err = true;
        toastShow(toast, "error", "Error", "Tasa Cambio de otros costos es requerida.");
      }
    }
    
    // else if(!values?.NombreSucursal?.IdProveedorCAI ){
    //   err = true;
    //   toastShow(toast, "error", "Error", "Debe seleccionar un proveedor CAI.");
    // }
    return !err;
  };

  const CambiarProveedorCAI = (e, op) => {
    let tempoValues = { ...values }
    tempoValues.IdProveedorCAI = e?.data?.IdProveedorCAI
    tempoValues.NombreSucursal = e?.data.NombreSucursal
    tempoValues.Factura = e?.data.Prefijo
    // console.log(tempoValues)
    setValues(tempoValues)
    op.current.toggle(e)
  }

  const agregraOrdenC = async(e, op) => {
    setLoading(true)
    const nuevosDetalles = await getOrdenesDetalles(e?.data?.IdPurchaseOrder)
    let cuentaSeleccionada
    if(e?.data?.IdCountry === 95){
      cuentaSeleccionada = cuentas.filter(i => i?.IdAccount === 15)
    }else{
      cuentaSeleccionada = cuentas.filter(i => i?.IdAccount === 16)
    }
    let tempoValues = { ...values }
    tempoValues.IdPurchaseOrder = e?.data?.IdPurchaseOrder
    tempoValues.PurchaseOrder = e?.data?.PurchaseOrder
    tempoValues.CustomerName = e?.data?.Expr1
    tempoValues.IdVendor = e?.data?.IdVendor
    tempoValues.IdCountry = e?.data?.IdCountry
    tempoValues.IdTerm = e?.data?.IdType
    tempoValues.Term = e?.data?.Type
    tempoValues.IdAccount = cuentaSeleccionada[0]?.IdAccount
    tempoValues.CuentaConcatenadaCont = cuentaSeleccionada[0]?.CuentaConcatenadaCont
    setValues(tempoValues)
    addOC(nuevosDetalles)
    setLoading(false)
    op.current.toggle(e)
  }

  const revisarFinanzas = async(e) => {
    if(e?.checked){
      if(values?.IdEstadoRevisado === 74){
        const todosTienenIdAccount = detalles.every((item) => item.IdAccount !== null && item.IdAccount !== undefined);
        const todosTienenIdSub = detalles.every((item) => item.IdSubConstruccion !== null && item.IdSubConstruccion !== undefined);
        if (!todosTienenIdAccount) {
          toastShow(toast, 'error', 'Error', 'No puede revisar. Todos los detalles deben tener una cuenta.')
          return; 
        }
        if (!todosTienenIdSub && serviciosNuevo) {
          toastShow(toast, 'error', 'Error', 'No puede revisar. Todos los detalles deben tener una construcción.')
          return; 
        }
    
        confirmDialog({
          message: "Esta seguro que desea guardar",
          header: "Marcar como Revisado",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si",
          accept: () => {
          if(!showPOColumn){
            guardarIngresosBodega(e.checked, userAuth?.IdUser);
          }else{
            guardarIngresos(e.checked, userAuth?.IdUser);
          }
          },
          rejectLabel: "No",
          style: { backgroundColor: "white" },
        });
      }else{
        toastShow(toast, 'error', 'Error', 'Debe marcar como recibido antes de pasarlo a revisado.')
      }
    }else{
      const resp = await volverARecibido(values?.IdIngreso)
      getIngreso()
    }
  }

  const recibidoFinanzas = async(e) => {
    if(e?.checked){  
      confirmDialog({
        message: "Esta seguro que desea guardar",
        header: "Marcar como Revisado",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: async () => {
          const respuestaDetalles = await cambiarRecibidofinanzas(values?.IdIngreso, userAuth?.IdUser);
          toastShow(toast, "success", "Editado", "Registros recibidos.");
          getIngreso()
        },
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });
    }else{
     const resp = await volverARecibido(values?.IdIngreso)
     getIngreso()
    }

  }

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVA REQUISA
  const getInfoNew = async () => {
    setLoading(true);
    const NIngreso = await ObtenerSiguienteNoIngreso();
    setNoIngreso(NIngreso);

    const d = {
      IdEstado: 25,
      StatusName: "Creado",
      FechaIngreso: new Date(),
      IdIngreso: -100,
      NumeroIngreso: NIngreso[0].NumeroIngreso,
      Factura: '',
      Comentarios: '',
      OCE:''
    };
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  const nuevoIngreso = () => {
    confirmDialog({
      message: "Esta seguro que desea crear un nuevo Ingreso",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        resetForm();
        setDetalles([]);
        getInfoNew();
        setIngresoToShow(null)
        setHabilitar(true);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const habilitarEncabezado = () => {
    if(habilitar){
      for (const detalle of detalles) {
        if (detalle.Inventario < detalle.Ingreso && detalle?.IdIngresoDetalle > 0) {
          if (true) {
            return false
          }
        }
      }
    }else{
      return false
    }
  };

  const habilitarEncabezado1 = () => {
    if(habilitar){
      for (const detalle of detalles) {
        if (detalle.Inventario < detalle.Ingreso && detalle?.IdIngresoDetalle > 0) {
          return true;
        }else{
          return false
        }
      }
    }else{
      return true
    }
  };

  const calcular = (tempoValues = values) => {
    setLoading(true)
    

    let sumMontosL = detalles.reduce((total, value) => total + value?.MontoL, 0);
    let sumMontosD = detalles.reduce((total, value) => total + value?.MontoD, 0);


    detalles.forEach(detail => {

      let EML = (detail.MontoL / sumMontosL) * (tempoValues?.EmbalajeL) //EMBALAJE LEMPIRAS
      let DL = (detail.MontoL / sumMontosL) * (tempoValues?.DesaduanajeL) //DESADUANAJE LEMPIRAS
      let FL = (detail.MontoL / sumMontosL) * (tempoValues?.FleteL) //FLETE LEMPIRAS
      let OCL = (detail.MontoL / sumMontosL) * (tempoValues?.OtrosCostosL) //OTROS COSTOS LEMPIRAS

      let DD = (detail.MontoD / sumMontosD) * (tempoValues?.DesaduanajeD) // DESADUANAJE $
      let FD = (detail.MontoD / sumMontosD) * (tempoValues?.FleteD) //FLETE $
      let EMD = (detail.MontoD / sumMontosD) * (tempoValues?.EmbalajeD) //EMBALAJE $
      let OCD = (detail.MontoD / sumMontosD) * (tempoValues?.OtrosCostosD) //OTROS COSTOS DOLARES $

      detail.EmbalajeL = EML
      detail.DesaduanajeL = DL
      detail.FleteL = FL
      detail.OtrosCostosL = OCL

      detail.EmbalajeD = EMD
      detail.DesaduanajeD = DD
      detail.FleteD = FD
      detail.OtrosCostosD = OCD

      detail.CostoL = (detail.MontoL + DL + FL + EML + OCL)
      detail.CostoD = (detail.MontoD + DD + FD + EMD + OCD)

      detail.PrecioL = detail.Precio
      detail.PrecioD = detail.PrecioD

      detail.PrecioUL = detail.CostoL / serviciosNuevo ? detail.BalanceReservado : detail.Ingreso
      detail.PrecioUD = detail.CostoD / serviciosNuevo ? detail.BalanceReservado : detail.Ingreso

      detail.SubTotal = detail.PrecioL * serviciosNuevo ? detail.BalanceReservado : detail.Ingreso
      detail.SubTotalD = detail.PrecioD * serviciosNuevo ? detail.BalanceReservado : detail.Ingreso
    })


    setTimeout(() => {
      setLoading(false)
    }, 200);

  }

  useEffect(() => {
    habilitarCAI2()
    // if(!values?.CustomerName?.IdVendor){
    //   console.log('------------------------');
    //   setValues({
    //     ...values,
    //     // NombreSucursal: '',
    //     IdProveedorCAI: null
    //   })
    // }
  }, [values?.IdVendor,values?.CustomerName?.IdVendor, values?.IdCountry]);

  const habilitarCAI2 = () => {
    let IdCountry = values?.IdCountry ? values?.IdCountry : values?.CustomerName?.IdCountry
    if(habilitar){
      if(IdCountry && IdCountry === 95){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }

  const onHide = () => {
    setShowDialogLiquidacion(false)
  }

  const AsignarMontosLiquidacion = (e, tempoV, op) => {
    if (tempoV) {
      let tempoValues = { ...values }

      tempoValues.EmbalajeD = RedondearNumero((tempoValues.EmbalajeD > 0 ? tempoValues.EmbalajeD : 0) + tempoV.MontoEmbalajeD)
      tempoValues.FleteD = RedondearNumero((tempoValues.FleteD > 0 ? tempoValues.FleteD : 0) + tempoV.MontoFleteD)
      tempoValues.DesaduanajeD = RedondearNumero((tempoValues.DesaduanajeD > 0 ? tempoValues.DesaduanajeD : 0) + tempoV.MontoDesaduanajeD)
      tempoValues.OtrosCostosD = RedondearNumero((tempoValues.OtrosCostosD > 0 ? tempoValues.OtrosCostosD : 0) + tempoV.MontoOtrosCostosD)

      tempoValues.EmbalajeL = RedondearNumero((tempoValues.EmbalajeL > 0 ? tempoValues.EmbalajeL : 0) + tempoV.MontoEmbalajeL)
      tempoValues.FleteL = RedondearNumero((tempoValues.FleteL > 0 ? tempoValues.FleteL : 0) + tempoV.MontoFleteL)
      tempoValues.DesaduanajeL = RedondearNumero((tempoValues.DesaduanajeL > 0 ? tempoValues.DesaduanajeL : 0) + tempoV.MontoDesaduanajeL)
      tempoValues.OtrosCostosL = RedondearNumero((tempoValues.OtrosCostosL > 0 ? tempoValues.OtrosCostosL : 0) + tempoV.MontoOtrosCostosL)

      tempoValues.IsDollar = tempoV.IdCurrency === 1 ? true : false
      setCheckDollar(tempoV?.IdCurrency === 1 ?? false)
   

      setValues(tempoValues)

      calcular(tempoValues)
    }

    // if (op) {
    //   op?.current.toggle(e)
    // }
  }

  const limpiarCAI = () => {
    setValues(prev => ({
      ...prev,
      IdProveedorCAI: null,
      NombreSucursal: '',
      Factura: ''
    }));
  };

  //MENSAJE PARA MOSTRAR TOOLTIP
  let mensaje;
  if(detalles.length > 0 && !isMateriaPrima){
    mensaje = "Ya existen detalles de repuestos"
  }else if(detalles.length > 0 && isMateriaPrima){
    mensaje = "Ya existen detalles de materia prima"
  }

  const DividirDetalle = () => {
    if (selectedDet?.length === 0) {
      toastShow(toast, 'error','Error','Debe seleccionar el detalle que desea dividir')
    } else {
      setDialogDividir(true)
    }
  }

  const hideDividir = () => {
    setDialogDividir(false)
    setSelected([])
    calcular()
  }


  return (
    <div className="d-flex flex-column">
      <Toast ref={toast} />
      <Card
        contenido={
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-start gap-2 mt-2">
              {/* No. Ingreso */}
              <span className="p-inputgroup " style={{ maxWidth: 222 }}>
                <span className=" field p-float-label">
                  <InputText
                    id="NumeroIngreso"
                    name="NumeroIngreso"
                    value={values?.NumeroIngreso}
                    autoFocus
                    onChange={handleInputChange}
                    style={{ fontWeight: "bold" }}
                    onKeyDown={(e) => (e.keyCode === 13 ? getIngreso() : null)}
                  />
                  <label htmlFor="idEncabezado">No. Ingreso</label>
                </span>

                <Button
                  icon="pi pi-search"
                  type="button"
                  className="p-button-info "
                  onClick={() => getIngreso()}
                  tooltip="Buscar Ingreso"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                />
              </span>

              {/* Tipo Ingreso */}
              <AutoCompleteDropdown
                name={"Inventario"}
                value={values?.Inventario}
                items={tiposIngreso}
                field={"Inventario"}
                enable={false}
                label={"Tipo Ingreso"}
                handleInputChange={handleInputChange}
              />

              {showPOColumn && (
                <div className="d-flex flex-row">
                  <span className=" p-float-label">
                    <InputText
                      value={values.PurchaseOrder}
                      style={{ width: "100%", borderEndEndRadius: 0 }}
                    />
                    <label htmlFor="PurchaseOrder">Orden de Compra</label>
                  </span>

                  <OverlayOC onChange={agregraOrdenC} detalles={detalles} />
                </div>
              )}

              {showPOColumn && (
                <div className=" p-float-label">
                  <InputText
                    id="OCE"
                    name="OCE"
                    value={values?.OCE}
                    onChange={handleInputChange}
                    disabled={habilitarEncabezado1()}
                    style={{ width: "100%" }}
                  />
                  <label htmlFor="OCE">OCE</label>
                </div>
              )}

              {showPOColumn && (
                <span className="p-float-label">
                  <InputText
                    id="CustomerName"
                    name="CustomerName"
                    disabled
                    value={values?.CustomerName}
                    style={{ width: 320 }}
                  />
                  <label htmlFor="CustomerName">Proveedor</label>
                </span>
              )}

              {!showPOColumn && (
                <>
                  <AutoCompleteDropdown
                    enable={habilitarEncabezado()}
                    // enable={habilitar}
                    name={"CustomerName"}
                    value={values?.CustomerName}
                    items={proveedor}
                    field={"CustomerName"}
                    label={"Proveedor"}
                    handleInputChange={handleInputChange}
                    onValueChange={handleProveedorChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                  />

                  <span className=" p-float-label">
                    <InputText
                      id="OCE"
                      name="OCE"
                      value={values?.OCE}
                      onChange={handleInputChange}
                      disabled={habilitarEncabezado1()}
                      style={{ width: "100%", padding: "6px 3px" }}
                    />
                    <label htmlFor="OCE">OCE</label>
                  </span>
                </>
              )}

              <div className="d-flex flex-row align-items-center">
                <div style={{ position: "relative", width: "100%" }}>
                  <span className="p-float-label" style={{ width: "100%" }}>
                    <InputText value={values.NombreSucursal} disabled />
                    <label htmlFor="NombreSucursal">CAI</label>
                  </span>
                  {(values.IdProveedorCAI && habilitar) && (
                    <button
                      type="button"
                      disabled={true}
                      onClick={limpiarCAI}
                      style={{
                        position: "absolute",
                        right: "0.5rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        color: "red",
                      }}
                      title="Quitar CAI"
                    >
                      ✖
                    </button>
                  )}
                </div>

                <OverlayProveedorCAI
                  IdProveedor={
                    values.CustomerName?.IdVendor || values?.IdVendor
                  }
                  values={values}
                  onChange={CambiarProveedorCAI}
                  habilitar={habilitarCAI2()}
                />
              </div>

              {/* Factura */}
              <span className="p-float-label">
                <InputText
                  disabled={habilitarEncabezado1()}
                  id="Factura"
                  name="Factura"
                  value={values?.Factura}
                  onChange={handleInputChange}
                  style={{ width: 320 }}
                />
                <label htmlFor="Factura">Factura</label>
              </span>

              {/* Fecha Factura*/}
              <span className="p-float-label">
                <Calendar
                  id="FechaFactura"
                  name="FechaFactura"
                  value={values?.FechaFactura}
                  dateFormat="dd/mm/yy"
                  disabled={habilitarEncabezado1()}
                  mask="99/99/9999"
                  onChange={(e) => handleInputChange(e, "FechaFactura")}
                  showIcon
                  style={{ height: 45 }}
                />
                <label htmlFor="FechaFactura">Fecha Factura</label>
              </span>

              {/* Terminos */}
              <AutoCompleteDropdown
                enable={!showPOColumn && habilitar}
                name={"Term"}
                value={values?.Term}
                items={term}
                field={"Term"}
                label={"Término de Compra"}
                handleInputChange={handleInputChange}
                onValueChange={handleProveedorChange}
              />

              {/* Tasa de Cambio */}
              <span className="p-float-label mx-2">
                <InputNumber
                  minFractionDigits={5}
                  maxFractionDigits={5}
                  id="TasaCambio"
                  name="TasaCambio"
                  value={values?.TasaCambio}
                  style={{ width: "100%" }}
                  onChange={handleInputChange}
                  disabled={
                    !habilitar ||
                    (userAuth?.IdRol !== 36 && userAuth?.IdRol !== 1)
                  }
                />
                <label htmlFor="TasaCambio">Tasa de Cambio</label>
              </span>

              {/* Comentarios */}
              <span className="p-float-label d-flex">
                <InputTextarea
                  disabled={habilitarEncabezado1()}
                  id="Comentarios"
                  name="Comentarios"
                  value={values?.Comentarios}
                  onChange={handleInputChange}
                  cols={100}
                  rows={2}
                  style={{
                    width: "100%",
                    maxHeight: "3rem",
                    maxWidth: "60vh",
                    height: "3rem",
                  }}
                />
                <label id="label_comentario" htmlFor="Comentarios">
                  Comentarios
                </label>
              </span>

              {/* Cuenta */}
              <div style={{ width: 360 }}>
                <AutoCompleteDropdown
                  enable={habilitar}
                  name={"CuentaConcatenadaCont"}
                  value={values?.CuentaConcatenadaCont}
                  items={cuentas}
                  field={"CuentaConcatenadaCont"}
                  label={"Cuenta"}
                  handleInputChange={handleInputChange}
                />
              </div>

              <div className="mt-2">
                <span className="mx-2 mt-4">Recibido Finanzas</span>
                <Checkbox
                  id="Recibido"
                  disabled={
                    !habilitar &&
                    (userAuth?.IdRol !== 1 || userAuth?.IdRol !== 36)
                  }
                  name="Recibido"
                  checked={
                    values.IdEstadoRevisado === 74 ||
                    values.IdEstadoRevisado === 75
                  }
                  onChange={(e) => recibidoFinanzas(e)}
                />
              </div>

              <div className="mt-2 mx-4">
                <span className="mx-2 mt-2">Revisado</span>
                <Checkbox
                  id="Revisado"
                  disabled={userAuth?.IdRol !== 1 && userAuth?.IdRol !== 36}
                  name="Revisado"
                  checked={values.IdEstadoRevisado === 75}
                  onChange={(e) => revisarFinanzas(e)}
                />
              </div>
            </div>

            {/* --------------------------BOTONES-----------------------  */}
            <div className="d-flex">
              <div
                className="d-flex flex-wrap gap-3 mb-2"
                style={{ width: "30%" }}
              >
                <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-3 flex-wrap justify-content-between">
                  {!showPOColumn && (
                    <Button
                      icon="pi pi-plus"
                      disabled={!habilitar}
                      type="button"
                      className="p-button-info encabezado__herramienta-botones"
                      tooltip="Agregar Items"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      onClick={(e) => {
                        if (verificarCampos()) {
                          agregarNuevaFila();
                        }
                      }}
                      tabIndex={8}
                    />
                  )}

                  {showPOColumn && values?.IdIngreso > 0 && (
                    <div className="d-flex flex-row">
                      <OverlayOCD
                        onChange={addSingleOC}
                        detalles={detalles}
                        IdPurchaseOrder={values?.IdPurchaseOrder}
                        habilitar={habilitar}
                      />
                    </div>
                  )}

                  <Button
                    icon="pi pi-save"
                    disabled={!habilitar}
                    className="p-button-primary encabezado__herramienta-botones"
                    tooltip="Guardar"
                    tooltipOptions={{ position: "top" }}
                    style={{ marginLeft: 1, height: "47px" }}
                    onClick={(e) => {
                      if (verificarCampos()) {
                        if (!showPOColumn) {
                          guardarIngresosBodega();
                        } else {
                          guardarIngresos();
                        }
                      }
                    }}
                  />

                  {values?.IdEstadoRevisado !== 75 && (
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      onClick={habilitarComponentes}
                      tooltip="Editar"
                      tooltipOptions={{ position: "top" }}
                      style={{ marginLeft: 1, height: "47px" }}
                      disabled={values?.IdIngreso <= 0}
                    />
                  )}

                  <Button
                    icon="pi pi-times"
                    type="button"
                    className="p-button-danger encabezado__herramienta-botones"
                    onClick={() => eliminarItemDetalle()}
                    tooltip="Cancelar"
                    disabled={!habilitar || detalles?.length <= 0}
                    tooltipOptions={{position: "top"}}
                    style={{ marginLeft: 1, height: "47px" }}
                  />
                  <Button
                    icon="pi pi-book"
                    type="button"
                    onClick={nuevoIngreso}
                    tooltip="Nuevo"
                    tooltipOptions={{ position: "top" }}
                    style={{ marginLeft: 1, height: "47px" }}
                  />
                  <Button
                    icon="pi pi-sync"
                    type="button"
                    onClick={() => getIngreso()}
                    tooltip="Cargar"
                    tooltipOptions={{ position: "top" }}
                    style={{ marginLeft: 1, height: "47px" }}
                  />

                  {(userAuth?.IdRol === 38 || userAuth?.IdRol === 25) && (
                    <Button
                      icon="pi pi-eye"
                      type="button"
                      onClick={() => setVerCostosBodega(!verCostosBodega)}
                      tooltip={
                        verCostosBodega ? "Ocultar Costos" : "Ver Costos"
                      }
                      tooltipOptions={{ position: "top" }}
                      style={{ marginLeft: 1.5, height: "47px" }}
                    />
                  )}

                  {isMateriaPrima && (
                    <Button
                      icon="ri-stack-line"
                      type="button"
                      onClick={() => {
                        setShowDialogLote(true);
                      }}
                      tooltip={"Agregar Lote"}
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                        style: { zIndex: 99999 },
                      }}
                      disabled={habilitarEncabezado1()}
                      style={{ marginLeft: 1, height: "47px" }}
                    />
                  )}

                  {ingresoSinOC && (
                    <Button
                      icon="pi pi-plus"
                      label={showPOColumn ? "Agregar sin PO" : "Agregar con PO"}
                      type="button"
                      onClick={handleTogglePOColumn}
                      tooltip={
                        showPOColumn
                          ? "Ocultar Orden Compra"
                          : "Agregar sin Orden Compra"
                      }
                      tooltipOptions={{ position: "top" }}
                      disabled={hab || detalles?.length > 0}
                      style={{ marginLeft: 1, height: "47px" }}
                    />
                  )}

                  {(values?.IdIngreso > 0 && serviciosNuevo) && (
                    <Button
                      label="Dividir Detalle "
                      icon="ri-split-cells-horizontal"
                      disabled={!habilitar}
                      onClick={() => DividirDetalle()}
                      style={{ marginLeft: 1, height: "47px" }}
                    />
                  )}
                </div>
              </div>

              <div className="d-flex" style={{ width: "70%" }}>
                <div className="d-flex">
                  <Card
                    titulo={<h6>Cálculos de Liquidación</h6>}
                    contenido={
                      <div className="d-flex flex-row gap-2">
                        <Button
                          icon="pi pi-print"
                          type="button"
                          className="p-button-secondary  encabezado__herramienta-botones mt-2"
                          onClick={() => {
                            setShowDialogLiquidacion(true);
                          }}
                          tooltip="Reconocimiento de Activos"
                          tooltipOptions={{
                            className: "purple-tooltip",
                            position: "top",
                            style: { zIndex: 99999 },
                          }}
                          style={{ marginLeft: 1 }}
                        />

                        <OverlayLiquidacionesDetalles
                          informacion={{ IdIngreso: values?.IdIngreso }}
                          close={() => {}}
                          AsignarLiquidacion={AsignarMontosLiquidacion}
                          habilitar={habilitar}
                        />

                        <div>
                          {values?.IdIngreso > 0 && (
                            <div className="d-flex flex-row">
                              <OverlayLiquidaciones
                                valoresIngreso={values}
                                AsignarLiquidacion={AsignarMontosLiquidacion}
                                habilitar={habilitar}
                                info={values}
                                detalles={detalles}
                                serviciosNuevo={serviciosNuevo}
                                showPOColumn={showPOColumn}
                                guardarIngresosBodega={guardarIngresosBodega}
                                guardarIngresos={guardarIngresos}
                                getIngreso={getIngreso}
                              />
                            </div>
                          )}
                        </div>

                        <div
                          className="d-flex"
                          style={{ alignItems: "center" }}
                        >
                          <Button
                            className="mt-2"
                            disabled={!habilitar || detalles?.length <= 0}
                            onClick={() => calcular(values)}
                            icon="ri-calculator-line"
                            tooltip="Cálcular"
                            tooltipOptions={{ style: { zIndex: 99999 } }}
                          />
                        </div>

                        <span
                          className="d-flex flex-row"
                          style={{ alignItems: "center" }}
                        >
                          <Checkbox
                            checked={checkDollar}
                            onChange={(e) => setCheckDollar(e.checked)}
                          />
                          <label className="mx-2">Is Dollar</label>
                        </span>
                      </div>
                    }
                  />
                  <div className="w-12">
                    <Card
                      titulo={<h6>Embalaje</h6>}
                      contenido={
                        <div
                          className="flex-row"
                          style={{ justifyContent: "center" }}
                        >
                          <div className="p-float-label">
                            <InputNumber
                              value={values?.EmbalajeL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              id="EmbalajeL"
                              name="EmbalajeL"
                              thousandSeparator=","
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>

                          <div className="mt-2 p-float-label">
                            <InputNumber
                              value={values?.EmbalajeD}
                              onChange={handleInputChange}
                              id="EmbalajeD"
                              name="EmbalajeD"
                              allowLeadingZeros
                              disabled
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                            />
                            <label htmlFor="username">Monto D</label>
                          </div>
                        </div>
                      }
                    />
                  </div>

                  <div className="w-12">
                    <Card
                      titulo={<h6>Desaduanaje</h6>}
                      contenido={
                        <div
                          className=" flex-row"
                          style={{ justifyContent: "center" }}
                        >
                          <div className="p-float-label">
                            <InputNumber
                              value={values.DesaduanajeL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              thousandSeparator=","
                              id="DesaduanajeL"
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              name="DesaduanajeL"
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>
                          <div className=" mt-2 p-float-label">
                            <InputNumber
                              value={values.DesaduanajeD}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              id="DesaduanajeD"
                              name="DesaduanajeD"
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                              disabled
                            />
                            <label htmlFor="username">Monto D</label>
                          </div>
                        </div>
                      }
                    />
                  </div>

                  <div className="w-12">
                    <Card
                      titulo={<h6>Flete</h6>}
                      contenido={
                        <div
                          className=" flex-row"
                          style={{ justifyContent: "center" }}
                        >
                          <div className="p-float-label">
                            <InputNumber
                              value={values.FleteL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              thousandSeparator=","
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              id="FleteL"
                              name="FleteL"
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>
                          <div className=" mt-2 p-float-label">
                            <InputNumber
                              value={values.FleteD}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              thousandSeparator=","
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              id="FleteD"
                              name="FleteD"
                              disabled
                            />
                            <label htmlFor="username">MontoD</label>
                          </div>
                        </div>
                      }
                    />
                  </div>

                  <div className="w-12">
                    <Card
                      titulo={<h6>Otros Costos</h6>}
                      contenido={
                        <div
                          className=" flex-row"
                          style={{ justifyContent: "center" }}
                        >
                          <div className="p-float-label">
                            <InputNumber
                              value={values.OtrosCostosL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                              id="OtrosCostosL"
                              name="OtrosCostosL"
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>
                          <div className=" mt-2 p-float-label">
                            <InputNumber
                              value={values.OtrosCostosD}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                              id="OtrosCostosD"
                              name="OtrosCostosD"
                              disabled
                            />
                            <label htmlFor="username">Monto D</label>
                          </div>
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            {showDialogLiquidacion && (
              <Dialog
                visible={showDialogLiquidacion}
                modal
                className="modal__contenedor modal__usuarios"
                onHide={onHide}
                style={{ width: "78%", height: "100%" }}
              >
                <LiquidacionDeIngresos ingreso={values} />
              </Dialog>
            )}

            {dialogDividir && (
              <ModalDividirDetalles
                dialogDividir={dialogDividir}
                hideDividir={hideDividir}
                selectedDet={selectedDet}
                detalles={detalles}
                setDetalles={setDetalles}
                values={values}
              />
            )}
          </div>
        }
      />
    </div>
  );
};

export default EncabezadoIngresos;